export const prefilledData = "• Initial physical assessment upon check in• Accommodation equipped with medical bed• 24hr care for ADLs (Activities of Daily Living)• Daily vital check recording• Doctor’s weekly visit• Medication management and dispensing of medication• meal– daily - Breakfast/Lunch/Tea/Dinner• Laundry and Housekeeping• Use of Call Alert Button within ALU facilities• Social and Daily Activities";

export const formatInitialValue = (value) => {
	return value
		.split('• ')
		.filter(line => line.trim() !== '')
		.map(line => `• ${line}`)
		.join('\n');
};

//steps
export const titleText = [
    'Admission',
    'Service Agreement',
    'Service Agreement - Schedule 1',
    'Service Agreement - Schedule 2',
    'Service Agreement - Schedule 3',
    'Service Agreement Acceptance',
    'PDPA',
    'Welcome to Komune Care'
];

export const admission_co_type = 'admission_co_type';
export const staff_checkin_type = 'staff_checkin_type';
export const guest_checkin_type = 'guest_checkin_type';
export const staff_checkout_type = 'staff_checkout_type';
export const guest_checkout_type = 'guest_checkout_type';
export const cr_acceptance_type = 'cr_acceptance_type';
export const cr_witness_type = 'cr_witness_type';
export const co_acceptance_type = 'co_acceptance_type';
export const co_witness_type = 'co_witness_type';
export const pdpa_co_type = 'pdpa_co_type';